import { PropsWithChildren } from 'react'
import { Flex } from '@chakra-ui/react'

const ColumnsWrapper = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Flex
      margin={{ lg: '0 -10px' }}
      css={{
        '@media (min-width: 64rem)': {
          '& > *': {
            margin: '0 10px',
          },
        },
      }}
    >
      {children}
    </Flex>
  )
}

export default ColumnsWrapper
